<template>
  <card class="card" title="Editar dirección">
    <div>
      <form @submit.prevent="handleSubmit">
        <div class="row">
          <div class="col-md-6">
            <fg-input
              type="text"
              label="Tipo"
              placeholder="Tipo"
              v-model="form.type"
              :class="{
               'is-invalid': submitted && $v.form.type.$error
              }"
            >
            </fg-input>
            <div
              v-if="submitted && $v.form.type.$error"
              class="invalid-feedback"
            >
              <span v-if="!$v.form.type.required"
                >El tipo es requerido</span
              >
            </div>
          </div>
          <div class="col-md-6">
            <fg-input
              type="text"
              label="Calle*"
              placeholder="Calle"
              v-model="form.calle"
              :class="{
               'is-invalid': submitted && $v.form.calle.$error
              }"
            >
            </fg-input>
            <div
              v-if="submitted && $v.form.calle.$error"
              class="invalid-feedback"
            >
              <span v-if="!$v.form.calle.required"
                >La calle es requerida</span
              >
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <fg-input
              type="text"
              label="Colonia*"
              placeholder="Colonia"
              v-model="form.colonia"
              :class="{
               'is-invalid': submitted && $v.form.colonia.$error
              }"
            >
            </fg-input>
            <div
              v-if="submitted && $v.form.colonia.$error"
              class="invalid-feedback"
            >
              <span v-if="!$v.form.colonia.required"
                >La colonia es requerida</span
              >
            </div>
          </div>
          <div class="col-md-6">
            <fg-input
              type="text"
              label="No. Exterior*"
              placeholder="Número exterior"
              v-model="form.numero_exterior"
              :class="{
               'is-invalid': submitted && $v.form.numero_exterior.$error
              }"
            >
            </fg-input>
            <div
              v-if="submitted && $v.form.numero_exterior.$error"
              class="invalid-feedback"
            >
              <span v-if="!$v.form.numero_exterior.required"
                >El no. exterior es requerido</span
              >
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <fg-input
              type="text"
              label="No. interior"
              placeholder="Número interior"
              v-model="form.numero_interior"
            >
            </fg-input>
          </div>
          <div class="col-md-6">
            <fg-input
              type="number"
              label="C.P.*"
              placeholder="Código Postal"
              maxlength="3"
              min="1" 
              max="999"
              v-model="form.cp"
              :class="{
               'is-invalid': submitted && $v.form.cp.$error
              }"
            >
            </fg-input>
            <div
              v-if="submitted && $v.form.cp.$error"
              class="invalid-feedback"
            >
              <span v-if="!$v.form.cp.required"
                >El C.P. es requerido</span
              >
              <span v-if="!$v.form.cp.minLength || !$v.form.cp.maxLength"
                >C.P. debe contar con 5 caracteres</span
              >
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <fg-input
              type="text"
              label="Ciudad*"
              placeholder="Ciudad"
              v-model="form.ciudad"
              :class="{
               'is-invalid': submitted && $v.form.ciudad.$error
              }"
            >
            </fg-input>
            <div
              v-if="submitted && $v.form.ciudad.$error"
              class="invalid-feedback"
            >
              <span v-if="!$v.form.ciudad.required"
                >La ciudad es requerida</span
              >
            </div>
          </div>
          <div class="col-md-6">
            <fg-input
              type="text"
              label="Estado*"
              placeholder="Estado"
              v-model="form.estado"
              :class="{
               'is-invalid': submitted && $v.form.estado.$error
              }"
            >
            </fg-input>
            <div
              v-if="submitted && $v.form.estado.$error"
              class="invalid-feedback"
            >
              <span v-if="!$v.form.estado.required"
                >El Estado es requerido</span
              >
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <fg-input
              type="text"
              label="País*"
              placeholder="País"
              v-model="form.pais"
              :class="{
               'is-invalid': submitted && $v.form.pais.$error
              }"
            >
            </fg-input>
            <div
              v-if="submitted && $v.form.pais.$error"
              class="invalid-feedback"
            >
              <span v-if="!$v.form.pais.required"
                >El País es requerido</span
              >
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <!-- Estación -->
            <vSelect 
              :options="stations"
              placeholder="Selecciona una estación*"
              v-model="form.station_id"
              :class="{
               'is-invalid': submitted && $v.form.station_id.$error
              }"
              />
            <div
              v-if="submitted && $v.form.station_id.$error"
              class="invalid-feedback"
            >
              <span v-if="!$v.form.station_id.required"
                >Selecciona una estación</span
              >
            </div>
          </div>
        </div>      

        <div><br/>
          <p-button 
            type="info" 
            @click.native.prevent="handleSubmit"
            style="margin-right: 10px;"
            >
            Enviar
          </p-button>
          <p-button type="danger" @click.native.prevent="handleCancel">
            Cancelar
          </p-button>
        </div>
        <div class="clearfix"></div>
      </form>
    </div>
  </card>
</template>
<script>
import { required, minLength, maxLength } from "vuelidate/lib/validators";
import addressService from '../../services/addressService'
import "vue-select/dist/vue-select.css";
import state from "../../store/state"
import vSelect from "vue-select";
import store from "../../store";
import swal from 'sweetalert'
export default {
  components:{
    vSelect
  },
  data() {
    return {
      stations: [],
      form: {
        version: 0,
        station_id: "",
        numero_exterior: "",
        numero_interior: "",
        estado: "",
        pais: "",
        calle: "",
        cp: "",
        type: "ESTACION",
        colonia: "",
        ciudad: ""
      },
      submitted: false
    };
  },
  beforeCreate() {
    store.dispatch('actionGetStations');
  },
  mounted () {
    this.stations = []
    if(
      localStorage.getItem('stationsJSON') &&
      JSON.parse(localStorage.getItem('stationsJSON')).length > 0
    ) {
        this.stations = localStorage.getItem('stationsJSON') 
          ? JSON.parse(localStorage.getItem('stationsJSON')) : []
    } else {
      setTimeout(() => {
        this.stations = state.stations.select
      }, 2000)
    }
    const id = this.$route.params.id;
    addressService.getByID(id).then(response => {
      this.form.station_id =
      {
        label: response.data.data.station_id.id + ' ' + response.data.data.station_id.name,
        option: response.data.data.station_id.id,
        id: response.data.data.station_id.id
      };
      this.form.numero_exterior = response.data.data.numero_exterior;
      this.form.numero_interior = response.data.data.numero_interior;
      this.form.estado = response.data.data.estado;
      this.form.pais = response.data.data.pais;
      this.form.calle = response.data.data.calle;
      this.form.cp = response.data.data.cp;
      this.form.colonia = response.data.data.colonia;
      this.form.ciudad = response.data.data.ciudad;
    })
  },
  validations: {
    form: {
      station_id: { required },
      numero_exterior: { required },
      estado: { required },
      pais: { required },
      calle: { required },
      cp: { 
        required,
        minLength: minLength(5),
        maxLength: maxLength(5)
      },
      type: { required },
      colonia: { required },
      ciudad: { required }
    }
  },
  methods: {
    handleSubmit (e) {
      const data = []
      this.submitted = true;

      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      addressService.update(this.$route.params.id, this.form).then(response => {
        if(response.data.error === false) {
          swal({
            title: 'Exitoso', 
            text: 'Se actualizo la dirección correctamente', 
            icon: 'success', 
            timer: 3000, 
            buttons: false
          })
          setTimeout(()=> {
            store.dispatch('actionGetAddress');
            this.$router.push("/direcciones");
          }, 3000)
        } else {
          swal({
            title: '¡Algo salio mal!',
            text: 'Consulte con el administrador', 
            icon: 'warning', 
            timer: 3000, 
            buttons: false
          })
        }
      })
    },
    handleCancel() {
      swal({
        title: '¡Aviso!',
        text: 'Se perdera tu progreso actual',
        icon: 'warning',
        buttons: true,
      }).then((result) => {
        if (result) {
          this.$router.push("/direcciones");
        }
      })
    }
  },
};
</script>
<style></style>
